import { Button, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ReconsentConnection } from './getReconsentConnections';

export const ConfirmRevoke = ({
    connection,
    onConfirm,
    onCancel
}: {
    connection: ReconsentConnection;
    onConfirm: () => void;
    onCancel: () => void;
}) => {
    return (
        <div className="space-y-l">
            <Text size="s" className="fs-mask dd-privacy-mask font-bold">
                {connection.bankName ? (
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_heading"
                        defaultMessage="Revoke access to {bankName}?"
                        values={{ bankName: connection.bankName }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_heading_unknown_bank"
                        defaultMessage="Revoke access to this account?"
                    />
                )}
            </Text>
            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.revoke_body"
                    defaultMessage="If you revoke access, we’ll stop seeing this account’s data. To reconnect it later, you’ll need to log in at your bank again."
                />
            </Text>
            <div className="space-y-s">
                <Button
                    variant="primary-rounded"
                    className="w-full"
                    onClick={onCancel}
                >
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_keep"
                        defaultMessage="Keep connected"
                    />
                </Button>
                <Button
                    variant="tertiary"
                    className="w-full"
                    onClick={onConfirm}
                >
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_confirm"
                        defaultMessage="Yes, revoke access"
                    />
                </Button>
            </div>
        </div>
    );
};
